<template>
  <div class="container document-font">
    <div class="card">
      <div class="d-flex card-body flex-column flex-fill">
        <div class="d-flex text-center flex-column flex-fill">
          <div class="flex-fill">
            <b-form-group label="Week to examine">
              <b-form-select v-model="selectedYearAndWeek" :options="yearAndWeekOptions" @change="onWeekChange"></b-form-select>
            </b-form-group>
          </div>
        </div>
        <div class="" v-if="activities.length > 0">
          <div class="d-flex">
            <div class="mr-3">
              Filters
            </div>
            <b-form-group class="ml-auto">
              <b-form-checkbox-group
                id="checkbox-group-1"
                v-model="selectedActivityTypes"
                :options="activityTypes"
                name="flavour-1"
              ></b-form-checkbox-group>
            </b-form-group>

          </div>
          <div class="mt-3 mb-2" v-for="activitiesRecord in activities" :key="activitiesRecord.activity_date">
            <div>
              <h3><b>{{ activitiesRecord.activity_date_string }}</b></h3>
            </div>
            <div v-for="activityType in selectedActivityTypes" :key="activityType">
              <div class="mt-3" v-if="activitiesRecord.activities.filter((a) => a.activity_type === activityType).length > 0">
                <span style="font-size: 1.3em;"><b>{{ activityType }}</b></span>
                <div class="d-flex mt-3 flex-column" v-for="activity in activitiesRecord.activities.filter((a) => a.activity_type === activityType)" :key="activity.group_id">
                  <div>
                    <b>{{ activity.subject }}</b>
                  </div>
                  <div>
                    <b>MAA Lead:</b> <span style="font-weight: 300">{{ activity.user_name }}</span>
                  </div>
                  <div>
                    <b>Organizations:</b> <span style="font-weight: 300">{{ getOrganizations(activity) }}</span>
                  </div>
                  <div>
                    <b>Summary:</b> <span style="font-weight: 300">{{ activity.note }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import activityAPI from '../../api/activity'
export default {
  name: 'activity-index',
  methods: {
    onWeekChange: function () {
      this.activities = []
      this.activityDates = []
      if (this.selectedYearAndWeek === null) {
        return
      }
      let splitYearAndWeek = this.selectedYearAndWeek.split('-')
      activityAPI.getActivitiesByYearAndWeek(splitYearAndWeek[0], splitYearAndWeek[1]).then(
        result => {
          this.activities = result.data.activities
          for (let i = 0; i < this.activities.length; i++) {
            for (let j = 0; j < this.activities[i].activities.length; j++) {
              let type = this.activities[i].activities[j].activity_type
              if (this.activityTypes.indexOf(type) === -1) {
                this.activityTypes.push(type)
                this.selectedActivityTypes.push(type)
              }
            }
          }
        }
      )
      this.activityTypes = this.activityTypes.sort()
    },
    getOrganizations (activity) {
      let organizationString = ''
      for (let i = 0; i < activity.organizations.length; i++) {
        organizationString += activity.organizations[i] + ', '
      }
      return organizationString.substring(0, organizationString.length - 2)
    }
  },
  data: function () {
    return {
      selectedYearAndWeek: null,
      yearAndWeekOptions: [],
      activities: [],
      selectedActivity: null,
      activityDates: [],
      activityTypes: [],
      selectedActivityTypes: []
    }
  },
  mounted: function () {
    activityAPI.getPrintableActivityIndex().then(
      result => {
        this.yearAndWeekOptions = result.data.data.dates_of_activities
      }
    )
  }
}
</script>

<style scoped>
  .document-font {
    font-family: Arial, Helvetica,  sans-serif
  }
</style>



// WEBPACK FOOTER //
// src/components/activities/PrintableActivityList.vue